import { useState, useEffect } from 'react';
import { ACSApi } from '../../../api';
import { TeamsWithUsersDto } from '../../../commonTypes/acs';
import { useContainer } from '../../useContainer';

const useHttpGetUsersTeams = (userSub: string) => {
    const ascApi: ACSApi = useContainer(ACSApi);

    const [teamsWithUsers, setTeamsWithUsers] = useState<TeamsWithUsersDto[]>([]);
    const [isReady, setIsReady] = useState(false);

    const getTeamsWithUsers = () => {
        const { exec, abort } = ascApi.getUsersTeamsWithUsers({
            params: { userSub },
            onSuccess: res => setTeamsWithUsers(res.body),
            onFinally: () => setIsReady(true),
        });

        exec();
        return abort;
    };

    useEffect(() => {
        getTeamsWithUsers();
    }, []);

    return { teamsWithUsers, setTeamsWithUsers, isReady };
};

export default useHttpGetUsersTeams;
